import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNote2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"note-2"} maskId="square-filled-radius-0-stroke-1-IconNote2"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V14.2071L14.2071 21H3V3ZM4 4V20H13V13H20V4H4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconNote2;
